import styled from "styled-components";
import { breakpoints, colors } from "src/variables";

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
`;

export const SearchIcon = styled.img`
  max-width: 50%;
  max-height: 50%;
  position: absolute;
  left: 1.5rem;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    left: 1rem;
  }
`;

export const SearchInput = styled.input`
  background: ${colors.white};
  color: ${colors.black};
  font-family: TeleNeo;
  font-weight: 700;
  height: 70px;
  font-size: 1.5rem;
  outline: none;
  width: 100%;
  padding: 10px 2rem 10px 5rem;
  border-radius: 92px;
  border: 2px solid transparent;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    font-size: 12px;
    height: 42px;
    padding: 10px 1rem 10px 2.5rem;
  }
`;

export const JobList = styled.div`
  width: 100%;
  max-height: 600px;
  overflow-y: auto;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    max-height: 400px;
  }
`;

export const JobItem = styled.div<{ highlighted: boolean }>`
  display: flex;
  color: #707070;
  justify-content: space-between;
  align-items: center;
  padding: 18px 2rem;
  background-color: ${({ highlighted }) =>
    highlighted ? "#E8E8E8" : "#ffffff"};
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    color: black;
    padding: 6px 1.5rem;
    background-color: unset;
  }
`;

export const HorizontalLine = styled.hr`
  width: 100%;
  border-top: 1px solid;
`;

export const Separator = styled.hr`
  display: none;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    display: block;
    width: 100%;
    border-top: 1px solid #ccc;
  }
`;

export const NoResults = styled.div`
  align-content: center;
  padding-top: 30px;
  font-size: 2rem;
  font-family: TeleNeo;
  font-weight: 700;
  text-align: center;
  height: 185px;
  color: ${colors.magenta};
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    font-size: 1rem;
  }
`;
